module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.enteredClass
  }, [(_vm.user !== undefined && _vm.user.attachment) ? _c('img', {
    attrs: {
      "src": _vm.user.attachment.url
    }
  }) : (_vm.user !== undefined && _vm.user.sex !== undefined) ? _c('img', {
    attrs: {
      "src": require("../assets/img/doctor_avatar.png")
    }
  }) : (_vm.user !== undefined && _vm.user.founder !== undefined) ? _c('img', {
    attrs: {
      "src": require("../assets/img/clinic_avatar.png")
    }
  }) : (_vm.user !== undefined && _vm.user.time !== undefined) ? _c('img', {
    attrs: {
      "src": require("../assets/img/clinic_avatar.png")
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42b3f3c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserAvatar.vue
// module id = 606
// module chunks = 0